import React, { useState } from 'react';
import { cryptoOptions } from '../utils/regionData';
import { Copy, Check } from 'lucide-react';
interface CryptoPaymentProps {
  onPaymentSuccess: () => void;
}
export function CryptoPayment({
  onPaymentSuccess
}: CryptoPaymentProps) {
  const [selectedCrypto, setSelectedCrypto] = useState('usdt');
  const [selectedNetwork, setSelectedNetwork] = useState('TRC20');
  const [copiedText, setCopiedText] = useState<string | null>(null);
  const handleCopyText = (text: string, identifier: string) => {
    navigator.clipboard.writeText(text);
    setCopiedText(identifier);
    setTimeout(() => setCopiedText(null), 2000);
  };
  const getWalletAddress = () => {
    if (selectedCrypto === 'usdt') {
      const network = cryptoOptions.usdt.networks.find(n => n.name === selectedNetwork);
      return network ? network.address : '';
    } else if (selectedCrypto === 'btc') {
      return cryptoOptions.btc.address;
    } else if (selectedCrypto === 'eth') {
      return cryptoOptions.eth.address;
    }
    return '';
  };
  return <div className="mt-4 border-t pt-4" data-id="element-14">
      <h3 className="font-bold text-gray-800 mb-3" data-id="element-15">Crypto Payment Details</h3>
      <div className="space-y-4" data-id="element-16">
        <div data-id="element-17">
          <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-18">
            Select Cryptocurrency
          </label>
          <select className="w-full p-2 border border-gray-300 rounded-lg" value={selectedCrypto} onChange={e => setSelectedCrypto(e.target.value)} data-id="element-19">
            <option value="usdt" data-id="element-20">USDT</option>
            <option value="btc" data-id="element-21">Bitcoin (BTC)</option>
            <option value="eth" data-id="element-22">Ethereum (ETH)</option>
          </select>
        </div>
        {selectedCrypto === 'usdt' && <div data-id="element-23">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-24">
              Select Network
            </label>
            <select className="w-full p-2 border border-gray-300 rounded-lg" value={selectedNetwork} onChange={e => setSelectedNetwork(e.target.value)} data-id="element-25">
              {cryptoOptions.usdt.networks.map(network => <option key={network.name} value={network.name} data-id="element-26">
                  {network.name}
                </option>)}
            </select>
          </div>}
        <div className="bg-gray-50 p-4 rounded-lg" data-id="element-27">
          <div className="flex justify-between items-center mb-2" data-id="element-28">
            <span className="text-sm text-gray-500" data-id="element-29">Amount</span>
            <span className="font-medium" data-id="element-30">$12.00</span>
          </div>
          <div className="flex justify-between items-center" data-id="element-31">
            <div data-id="element-32">
              <div className="text-sm text-gray-500" data-id="element-33">Wallet Address</div>
              <div className="font-mono text-sm break-all" data-id="element-34">
                {getWalletAddress()}
              </div>
            </div>
            <button onClick={() => handleCopyText(getWalletAddress(), 'wallet-address')} className="p-1 rounded-full hover:bg-gray-200 ml-2 flex-shrink-0" data-id="element-35">
              {copiedText === 'wallet-address' ? <Check className="h-5 w-5 text-green-600" data-id="element-36" /> : <Copy className="h-5 w-5 text-gray-600" data-id="element-37" />}
            </button>
          </div>
        </div>
        <div className="text-sm text-gray-600" data-id="element-38">
          Please send exactly $15 worth of {selectedCrypto.toUpperCase()} to the
          address above.
        </div>
        <button onClick={onPaymentSuccess} className="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 transition" data-id="element-39">
          I've Made Payment
        </button>
      </div>
    </div>;
}